import { buildMapId, mapPreviewUrl, type MapVariant } from "@dailywars/core/engine";
import { toUtcDateString } from "@dailywars/core/entitlements/mapAccess";

export function todayMapPreviewUrl(variant: MapVariant, date = new Date()): string {
  return mapPreviewUrl(buildMapId(toUtcDateString(date), variant));
}

export function todayStandardPreviewUrl(date = new Date()): string {
  return todayMapPreviewUrl("standard", date);
}

export function todayPremiumPreviewUrl(date = new Date()): string {
  return todayMapPreviewUrl("premium", date);
}
